import { buildCreateSlice, asyncThunkCreator } from '@reduxjs/toolkit';

import { initialState } from './initial';
import { reducers } from './reducers';

export const createAppSlice = buildCreateSlice({
  creators: { asyncThunk: asyncThunkCreator },
});

export const btvMediaSlice = createAppSlice({
  name: 'btvMedia',
  initialState,
  reducers,
});

export const { fetchBtvMedia, clearBtvMedia } = btvMediaSlice.actions;

export default btvMediaSlice.reducer;
